import { Box, Button, Card, CardActions, CardContent, Container, Drawer, FormControl, FormHelperText, Slide, Typography, CircularProgress } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultUpdateDemographic, updateDemographicField } from '../../../../redux/enrollments/action';
import { updateDemographics, updateDemographicsCleanUp } from '../../../../redux/demographics/actions';
import { formatDate } from '../../../common/functionUtils';
import { validateZipCode } from '../../../../utils/format-utils';
import ManageProfile from '../../../profileSetup/ManageProfile';
import Label from '../../../common/type/Label';

const useStyles = makeStyles((theme) => {
    return ({
        drawerPaper: {
            [theme.breakpoints.down('sm')]: {
                width: '100vw',
            },
            width: 411,
            backgroundColor: 'white'
        },
    });
});



const ProfileCard = () => {
    const [openRequestDrawer, setOpenRequestDrawer] = useState(false);
    const [userDrawer, setUserDrawer] = useState(false);
    const formattedAddress = useSelector(state => state?.enrollments?.enrollmentsDetails?.formattedAddress);
    const selfEnrollmentsFromStore = useSelector(state => state?.enrollments?.readableEnrollmentsDetails);
    const city = useSelector(state => state?.enrollments?.enrollmentsDetails?.city);
    const zipCode = useSelector(state => state?.enrollments?.enrollmentsDetails?.zipCode);
    const state = useSelector(state => state?.enrollments?.enrollmentsDetails?.state);
    const readableEnrollments = useSelector(state => state?.enrollments?.readableEnrollmentsDetails);
    const memberSelf = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails?.self
    );
    const dependentEnrollments = useSelector(state => state?.dependentEnrollments);
    const maLoadingFromStore = useSelector(state => state?.memberAccounts?.loading);

    const [error, setError] = useState({
        errorForZipCodeValid: false,
        errorForZipCodeValidText: '',
    });
    const dispatch = useDispatch();


    const aptSuiteRef = useRef(null);


    const handleChange = (event) => {
        dispatch(updateDemographicField(event.target.name, event.target.value));
    };
    const classes = useStyles();

    const handleSubmit = (event) => {
        event.preventDefault();
        let addressString;
        if (!validateZipCode(zipCode)) {
            setError({ ...error, errorForZipCodeValid: true, errorForZipCodeValidText: 'Zip code format should be 12345' });
            return;
        }
        if (aptSuiteRef.current.value) {
            addressString = formattedAddress.trimEnd() + ', ' + aptSuiteRef.current.value.trimEnd() + ', ' + city.trimEnd() + ', ' + state.trimEnd() + ' - ' + zipCode.trimEnd();
        }

        else {
            addressString = formattedAddress.trimEnd() + ', ' + city.trimEnd() + ', ' + state.trimEnd() + ' - ' + zipCode.trimEnd();
        }
        dispatch(updateDemographics(addressString, localStorage.getItem('tenantHandle')));
        setOpenRequestDrawer(false);

        setError({ ...error, errorForZipCodeValid: false, errorForZipCodeValidText: '' });
    };
    const handleCancel = () => {
        setOpenRequestDrawer(false);
        dispatch(setDefaultUpdateDemographic(readableEnrollments));
    };
    useEffect(() => {
        if (error.errorForZipCodeValid && validateZipCode(zipCode)) {
            setError({ ...error, errorForZipCodeValid: false, errorForZipCodeValidText: '' });
        }
    }, [zipCode]);
    if (maLoadingFromStore) {
        return <CircularProgress />;
    }
    return <>
        <Box className='securityBox'>
            <Card className='securityBoxHeader addAddressContainer'>
            <h3 className='privacypolicy-section'><Label id="manageProfile" /></h3>
            </Card>

            {readableEnrollments == null ? <>
                <ManageProfile
                    isSettingsSection={true}
                    showNavActions={true} data={null} />
                {dependentEnrollments && dependentEnrollments.length > 0 && <Card className='securityPassword securityPasswordTop'>
                    <CardContent className='profileNameSection'>
                        <Typography variant='body1'>
                           <Label id="currentAddress" />
                        </Typography>
                    </CardContent>
                    <CardContent className='profileGenderDescription'>
                        <Typography vriant='body1'>
                            {dependentEnrollments[0]?.formattedAddress + ', '}
                        </Typography>
                        <Typography vriant='body1'>
                            {dependentEnrollments[0]?.zipCode}
                        </Typography>
                    </CardContent>
                    <CardActions className='profileDOBSection'>
                        <Button variant='contained' className='settingsBTN' disabled onClick={() => {
                            setOpenRequestDrawer(true);
                            dispatch(updateDemographicsCleanUp());
                        }} >Update</Button>
                    </CardActions>
                </Card>}
            </> : <>
                <>

                    <Card className='securityPassword'>
                        <CardContent className='profileNameSection'>
                            <Typography variant='body1'>
                                {memberSelf?.firstName + ' ' + memberSelf?.lastName}
                            </Typography>

                        </CardContent>
                        <CardContent className='profileGenderDescription'>
                            <Typography vriant='body1'>
                                <Label id="gender" />

                </Typography>
                            <Typography vriant='body1'>
                                {selfEnrollmentsFromStore?.genderDescription === 'Male' ? <Label id='maleText'/> : <Label id='femaleText'/>}
                            </Typography>
                        </CardContent>
                        <CardContent className='profileDOBSection'>
                            <Typography>
                                <Label id="dateOfBirth" />
                        </Typography>
                            <Typography vriant='body1'>
                                {formatDate(selfEnrollmentsFromStore?.birthDate)}
                            </Typography>
                        </CardContent>

                        {/* <CardContent className='passwordChangeText'>
                    <Typography vriant='body1'>
                    </Typography>
                </CardContent> */}
                        {/* <CardActions className='passwordChangeBtnG'>
                    <Button variant='contained' color='secondary' onClick={() => setUserDrawer(true)} >
                        View & Update
        </Button>
                </CardActions> */}
                    </Card>
                    <Card className='securityMFA'>
                        <CardContent className='profileNameSection'>
                            <Typography variant='body1'>
                                <Label id='currentAddress'/>
        </Typography>
                            {/* <Typography variant='body1'>
                        {selfEnrollmentsFromStore?.formattedAddress + ', ' + selfEnrollmentsFromStore?.zipCode}
                    </Typography> */}
                        </CardContent>
                        <CardContent className='profileGenderDescription'>
                            <Typography vriant='body1'>
                                {
                                    readableEnrollments?.formattedAddress + ', '}
                            </Typography>
                            <Typography vriant='body1'>
                                {readableEnrollments?.zipCode}
                            </Typography>
                        </CardContent>
                        <CardActions className='profileDOBSection'>
                            <Button variant='contained' className='settingsBTN' onClick={() => {
                                setOpenRequestDrawer(true);
                                dispatch(updateDemographicsCleanUp());
                            }} ><Label id="updateS" /></Button>
                        </CardActions>
                    </Card>
                    {userDrawer && <Drawer anchor='right' classes={{ paper: classes?.drawerPaper }} variant='temporary' className='drawerForRequestCard' transitionDuration={500} open={userDrawer} onClose={() => setOpenRequestDrawer(false)}>
                        <Slide direction='left' in={userDrawer}>
                            <Box className='drawerBox'>
                                <Box className='drawerBoxContent'>
                                    <Container className='orderCardHeader'>
                                        <Typography variant='h5'>Update Basic Info</Typography>
                                        <CancelOutlinedIcon onClick={() => setUserDrawer(false)} />
                                    </Container>
                                    <Container className='settingsSubHeader'>
                                        To update your basic demographic information, please dial 211 or log in to your Texas Benefits
                                <br />
                                Account Page: <a rel="noreferrer" href="https://yourtexasbenefits.com/Learn/Home" target="_blank">yourtexasbenefits.com</a>
                                        {/* <Typography variant='body1' color='primary'></Typography> */}
                                    </Container>
                                </Box>
                            </Box>
                        </Slide>
                    </Drawer>}

                </>

            </>}
        </Box>
        <Card className='dependentSubText'>
            <Label id="dependentsDemographicUpdateInfo" />
            : <Typography component='span' variant='body1' color='primary'><a rel="noreferrer" href="https://yourtexasbenefits.com/Learn/Home" target="_blank">yourtexasbenefits.com</a></Typography>
        </Card>
        {openRequestDrawer && <Drawer anchor='right' classes={{ paper: classes?.drawerPaper }} variant='temporary' className='drawerForRequestCard' transitionDuration={500} open={openRequestDrawer} onClose={handleCancel}>
            <Slide direction='left' in={openRequestDrawer}>
                <Box className='drawerBox profileDrawerBox' >
                    <Box className='drawerBoxContent'>
                        <Container className='orderCardHeader'>
                            <Typography variant='h5'><Label id="updateAddress"/></Typography>
                            <CancelOutlinedIcon onClick={handleCancel} />
                        </Container>
                        <Container component='form' className='formContainer' maxWidth='100%' onSubmit={handleSubmit}>
                            <FormControl className='newAddresContainer'>
                                <div>
                                    <input className='inputfield' htmlFor='streetAddress' value={formattedAddress} onChange={handleChange} name='formattedAddress'></input>
                                    <label id='streetAddress' className='labelForInput'><Label id="StreetAddress"/></label>
                                </div>
                                <div>
                                    <input className='inputfield' htmlFor='apartmentNumber' name='aptSuitNumber' onChange={handleChange} ref={aptSuiteRef} ></input>
                                    <label id='apartmentNumber' className='labelForInput'><Label id="apartment"/></label>
                                </div>
                                <div>
                                    <input className='inputfield' required htmlFor='city' name='city' value={city} onChange={handleChange}></input>
                                    <label id='city' className='labelForInput'><Label id="City"/></label>
                                </div>
                                <div>
                                    <div>
                                        <FormHelperText error={error.errorForZipCodeValid}>{error.errorForZipCodeValidText}</FormHelperText>
                                        <input className='inputfield' required htmlFor='zipcode' name='zipCode' value={zipCode} onChange={handleChange}></input>
                                        <label id='zipcode' className='labelForInput'><Label id="ZIPCode"/></label>
                                    </div>
                                    <div>
                                        <input className='inputfield' required htmlFor='state' name='state' value={state} onChange={handleChange}></input>
                                        <label id='state' className='labelForInput'><Label id="State" /></label>
                                    </div>
                                </div>
                            </FormControl>

                            <FormControl className='dependentActions'>
                                <Button onClick={handleCancel} id='clearRequestBtn' className='dependentClear'><Label id="CANCEL"/></Button>
                                <Button variant='contained' id='submitRequestBtn' className='submitButton profileSubmit' type='submit' disabled={!city?.trimEnd() || !zipCode?.trimEnd() || !state?.trimEnd()}>
                                    {/* <Label id="submitOrder"></Label> */}
                                    <Label id="update" />
                                </Button>
                            </FormControl>
                        </Container>
                        <Typography varaint='body1' className='drawerText'>
                            {/* <Label id='drawerText0'></Label> */}
                        </Typography>
                        <Typography variant='body1' className='drawerText'>
                            {/* <Label id="drawerText1"></Label> */}
                        </Typography>
                        <Typography variant='body1' className='drawerText'>
                            {/* <Label id="drawerText2"></Label> */}
                        </Typography>
                        <Typography variant='body1' className='drawerText'>
                            {/* <Label id="drawerText3"></Label> */}
                        </Typography>
                    </Box>

                </Box>
            </Slide>
        </Drawer>}
    </>;
};


export default ProfileCard;
